import { Component } from "@angular/core";
import { FieldType } from "@kre-form/core";

@Component({
  selector: "kreform-field-ion-line",
  template: ` <div><hr /></div>`,
})
export class KreFormFieldIonLine extends FieldType {}
